import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types'
import '../../App.css'
import Button from 'react-bootstrap/esm/Button';
import { Link } from 'react-router-dom';
import { authCredentials } from '../../Models/AuthCredentials';
import { DeleteFeatureFlag, DeleteConfiguration } from '../../api/Api';
import DeleteModal from '../Modals/DeleteModal';
import { TableType } from '../../TableConstants';

const FeaturesTable =  ({ cols, data, tableType, bordered, hoverable, striped}) => {
    const [showModal, setShowModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});
    const [tableData, setTableData] = useState(data);
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({});

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = (itemToDelete) => {
        setItemToDelete(itemToDelete);
        setShowModal(true)
    };

    async function deleteSelectedItem(data){
        let credentials = new authCredentials(data.username, data.password);
        let filteredArray;

        try{
            if(tableType === TableType.FeatureFlag)
            {
                await DeleteFeatureFlag(data.serviceName, data.flagName, credentials);
                filteredArray = tableData.filter(featureFlag => featureFlag.FlagName !== data.flagName);
            }else
            {
                await DeleteConfiguration(data.productName, data.configName, credentials);
                filteredArray = tableData.filter(configuration => configuration.ConfigurationName !== data.configName);
            }

            setTableData(filteredArray);
            setItemToDelete({});
            setShowModal(false);
        } catch(err){
            handleErrorResponse(err.response);
        }
    }

    function handleErrorResponse(response){
        if (response.status === 400){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"Invalid Login"
            }
            setAlertData(data);
        }
        else if (response.status === 401){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"User is not authorized"
            }
            setAlertData(data);
        }
        else{
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:response=response.data.Message
            }
            setAlertData(data);
        }
    }

    return (
        <div className="table-responsive">
            <table className={`table ${bordered ? 'table-bordered' : 'table-borderless'} ${hoverable && 'table-hover'} ${striped && 'table-striped'} `}>
                <thead>
                    <tr>
                        {cols.map((headerItem, index) => (
                            <th key={index}>{headerItem.title}</th>
                        ))}
                        <th key={'actions'}>Modify</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((item, index) => (
                        <tr key={index}>
                            {cols.map((col, key) => (
                                <td key={key}>{col.render(item)}</td>

                            ))}
                            {
                            tableType === TableType.FeatureFlag ?
                            <td>
                                <React.Fragment>
                                    <Link to="featureFlag/edit" state={{ featureFlagName: item.FlagName, serviceName: item.ServiceName}}>
                                        <Button variant="secondary">Edit</Button>
                                    </Link>
                                    <Button variant="outline-danger" onClick={() => handleShowModal(item)}>Delete</Button>
                                    {showModal ? 
                                        <DeleteModal itemType={tableType} showModal={showModal} handleCloseModal={handleCloseModal} deleteItem={deleteSelectedItem} itemToDelete={itemToDelete} showAlert={showAlert} alertData={alertData} /> 
                                        : ""}     
                                </React.Fragment>
                            </td>
                            :
                            <td>
                                <React.Fragment>
                                    <Link to="/configuration/edit" state={{productName: item.ProductName, configurationName: item.ConfigurationName}}>
                                        <Button variant="secondary">Edit</Button>
                                    </Link>
                                    <Button variant="outline-danger" onClick={() => handleShowModal(item)}>Delete</Button>
                                    {showModal ? 
                                        <DeleteModal itemType={tableType} showModal={showModal} handleCloseModal={handleCloseModal} deleteItem={deleteSelectedItem} itemToDelete={itemToDelete} showAlert={showAlert} alertData={alertData} /> 
                                        : ""}     
                                </React.Fragment>
                            </td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

FeaturesTable.propTypes = {
    cols: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    bordered: PropTypes.bool,
    hoverable: PropTypes.bool,
    striped: PropTypes.bool,
    isDark: PropTypes.bool,
}

FeaturesTable.defaultProps = {
    bordered: true,
    hoverable: false,
    striped: false,
    isDark: false,
}

export default FeaturesTable;